import React from "react";
import { useTranslation } from "react-i18next";

// custom hooks
import { useBreakpoint } from "../Breakpoint/BreakpointProvider";

// assets
import partyIcon from "../../../assets/image/icons/party-popper.svg";

// propstype
import { WelcomeBannerProps } from "./types/propsType";

// styles
import styles from "./WelcomeBanner.module.scss";

const WelcomeBanner: React.FC<WelcomeBannerProps> = ({ username }) => {
  const { t } = useTranslation();
  const viewPortType = useBreakpoint();

  const isDesktopView = ['xs', 'sm', 'md'].indexOf(viewPortType) === -1;

  if (!username) return null;

  return (
    <div className={styles['welcome-banner']}>
      <img src={partyIcon} width={isDesktopView ? '40px' : '35px'} height={isDesktopView ? '40px' : '35px'} alt="Party" className={styles['welcome-banner__icon']} />
      <div className={styles['welcome-banner__section']}>
        <div className={styles['welcome-banner__section__text']} style={{ maxWidth: isDesktopView ? 'calc(90vw)' : 'calc(100vw)' }} >{`${t('dashboard.home.label.welcome')}, `}
          <span className={styles['text_italic']}>{`${username}!`}</span>
        </div>
      </div>
    </div>
  )
};

export default WelcomeBanner;